import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const InfoToolTipIcon: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--info-tooltip-Icon')}
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={icon}
  >
    <path
      d="M12 3.5a8.5 8.5 0 110 17 8.5 8.5 0 010-17zm0 1a7.5 7.5 0 100 15 7.5 7.5 0 000-15zm.5 6.045v6.133h-1v-6.133h1zm-.59-3.636a1 1 0 11-.002 2.001 1 1 0 01.001-2z"
      fill="#000"
      fillRule="evenodd"
    />
  </svg>
);

export default InfoToolTipIcon;
